<app-route-preloader *ngIf="showGlobalPreloader"></app-route-preloader>
<app-header></app-header>
<router-outlet #outlet="outlet"></router-outlet>
<app-footer [hideMainFooter]="hideFooter"></app-footer>
